/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DocumentViewerState {
  email: string | null;
  token: string | null;
}

const initialState: DocumentViewerState = {
  email: null,
  token: null,
};

const documentViewer = createSlice({
  name: 'documentViewer',
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    logout: (state) => {
      state.email = null;
    },
  },
});

export const {
  setEmail, setToken, logout,
} = documentViewer.actions;

export default documentViewer;
